"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var _marked = /*#__PURE__*/_regenerator().m(divider);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.millify = void 0;
var options_1 = require("./options");
var utils_1 = require("./utils");
// Most commonly used digit grouping base.
var DIGIT_GROUPING_BASE = 1000;
/**
 * Generator that divides a number until a decimal value is found.
 *
 * The denominator is defined by the numerical digit grouping base,
 * or interval. The most commonly-used digit group interval is 1000.
 *
 * e.g. 1,000,000 is grouped in multiples of 1000.
 */
function divider(value) {
  var denominator, result;
  return _regenerator().w(function (_context) {
    while (1) switch (_context.n) {
      case 0:
        // Create a mutable copy of the base.
        denominator = DIGIT_GROUPING_BASE;
      case 1:
        if (!true) {
          _context.n = 4;
          break;
        }
        result = value / denominator;
        if (!(result < 1)) {
          _context.n = 2;
          break;
        }
        return _context.a(2);
      case 2:
        _context.n = 3;
        return result;
      case 3:
        // The denominator is increased every iteration by multiplying
        // the base by itself, until a decimal value remains.
        denominator *= DIGIT_GROUPING_BASE;
        _context.n = 1;
        break;
      case 4:
        return _context.a(2);
    }
  }, _marked);
}
/**
 * millify converts long numbers to human-readable strings.
 */
function millify(value, options) {
  var _a;
  // Override default options with options supplied by user.
  var opts = options ? Object.assign(Object.assign({}, options_1.defaultOptions), options) : options_1.defaultOptions;
  if (!Array.isArray(opts.units) || !opts.units.length) {
    throw new Error("Option `units` must be a non-empty array");
  }
  // If the input value is invalid, then return the value in string form.
  // Originally this threw an error, but was changed to return a graceful fallback.
  var val;
  try {
    val = utils_1.parseValue(value);
  } catch (e) {
    if (e instanceof Error) {
      console.warn("WARN: ".concat(e.message, " (millify)"));
    }
    // Invalid values will be converted to string as per `String()`.
    return String(value);
  }
  // Add a minus sign (-) prefix if it's a negative number.
  var prefix = val < 0 ? "-" : "";
  // Work only with positive values for simplicity's sake.
  val = Math.abs(val);
  // Keep dividing the input value by the digit grouping base
  // until the decimal and the unit index is deciphered.
  var unitIndex = 0;
  var _iterator = _createForOfIteratorHelper(divider(val)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var result = _step.value;
      val = result;
      unitIndex += 1;
    }
    // Return the original number if the number is too large to have
    // a corresponding unit. Returning anything else is ambiguous.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var unitIndexOutOfRange = unitIndex >= opts.units.length;
  if (unitIndexOutOfRange) {
    return value.toString();
  }
  // Round decimal up to desired precision.
  var rounded = utils_1.roundTo(val, opts.precision);
  // Fixes an edge case bug that outputs certain numbers as 1000K instead of 1M.
  // The rounded value needs another iteration in the divider cycle.
  var _iterator2 = _createForOfIteratorHelper(divider(rounded)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _result = _step2.value;
      rounded = _result;
      unitIndex += 1;
    }
    // Calculate the unit suffix and make it lowercase (if needed).
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var unit = (_a = opts.units[unitIndex]) !== null && _a !== void 0 ? _a : "";
  var suffix = opts.lowercase ? unit.toLowerCase() : unit;
  // Add a space between number and abbreviation.
  var space = opts.space ? " " : "";
  // Replace decimal mark if desired.
  var formatted = rounded.toString().replace(options_1.defaultOptions.decimalSeparator, opts.decimalSeparator);
  return "".concat(prefix).concat(formatted).concat(space).concat(suffix);
}
exports.millify = millify;
exports.default = millify;